import { render } from "./access-agent-save.vue?vue&type=template&id=18af1d0c"
import script from "./access-agent-save.vue?vue&type=script&lang=js"
export * from "./access-agent-save.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__